<div class="filter-container flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-end">

  <div class="flex sm:w-1/2 lg:w-auto">
    <p-select
      *ngIf="quickOptionsAvailable"
      [(ngModel)]="selectedQuickOption"
      [options]="quickOptions"
      optionLabel="label"
      placeholder="Szybki wybór"
      (onChange)="onQuickOptionChange()"
      class="w-full"
    ></p-select>
  </div>

  <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:w-3/4 lg:w-auto">

    <p-datepicker
      #datePicker
      [(ngModel)]="range"
      [firstDayOfWeek]="1"
      selectionMode="range"
      [placeholder]="'Wybierz zakres'"
      [readonlyInput]="true"
      dateFormat="dd.mm.yy"
      (onSelect)="onDateRangeSelect()"
      [iconDisplay]="'input'"
      [showIcon]="true"
      [showButtonBar]="true"
      [numberOfMonths]="1"
      [styleClass]="'w-full md:w-auto'"
      [minDate]="minDate"
      [maxDate]="maxDate"
    ></p-datepicker>

    <div class="flex gap-2">
      <p-button
        pTooltip="Poprzedni tydzień"
        tooltipPosition="top"
        icon="pi pi-chevron-left"
        variant="outlined"
        (onClick)="onPreviousWeek()"
      ></p-button>

      <p-button
        pTooltip="Następny tydzień"
        tooltipPosition="top"
        icon="pi pi-chevron-right"
        variant="outlined"
        (onClick)="onNextWeek()"
      ></p-button>
    </div>

  </div>

</div>
